@if (revoteDetail$ | async; as revote) {
  <div class="management-form-container">
    <h2>Attributes</h2>
    <form [formGroup]="form">
      <div  class="flex-space-between-center flex-row-wrap" >
        <label class="flex-40" >Name</label>
        <mat-form-field class="flex-60" >
          <input [attr.data-testid]="'revote_name_text'" matInput required placeholder="Name"
            formControlName="name" [readonly]="readOnlyState">
          @if (form.controls['name'].invalid && !form.controls['name'].value) {
            <mat-error> Please enter a Name </mat-error>
          }
        </mat-form-field>
      </div>
      <div  class="flex-space-between-center flex-row-wrap" >
        <label class="flex-40" >Consumer</label>
        <mat-form-field class="flex-60" >
          <input [attr.data-testid]="'revote_consumer_text'" matInput required placeholder="Consumer" formControlName="consumer"
            [readonly]="true">
          @if (form.controls['consumer'].invalid && !form.controls['consumer'].value) {
            <mat-error> Please enter a Consumer
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div  class="flex-space-between-center flex-row-wrap" >
        <label class="flex-40" >Open Date</label>
        <emm-effective-date-selection
          source="management"
          [effectiveDate]="prevOpenDate"
          [label]="'Open Date'"
          (effectiveDateChange)="selectOpenDate($event)" class="flex-60">
        </emm-effective-date-selection>
      </div>
      <div  class="flex-space-between-center flex-row-wrap" >
        <label class="flex-40" >Close Date</label>
        <emm-effective-date-selection
          source="management"
          [effectiveDate]="prevCloseDate"
          [label]="'Close Date'"
          (effectiveDateChange)="selectCloseDate($event)" class="flex-60">
        </emm-effective-date-selection>
      </div>
      <div  class="flex-space-between-center flex-row-wrap" >
        <label class="flex-40" >Effective Date</label>
        <emm-effective-date-selection
          source="management"
          [effectiveDate]="prevEffectiveDate"
          [label]="'Effective Date'"
          (effectiveDateChange)="selectEffectiveDate($event)" class="flex-60">
        </emm-effective-date-selection>
      </div>
      <div  class="flex-space-between-center flex-row-wrap" >
        <label class="flex-40" >Categories</label>
        <mat-card-content class="flex-100" >
          <mat-list class="ml-3" style="height: 220px; overflow: scroll;">
            @for (category of categories$ | async; track category) {
              <mat-list-item style="height: 40px;">
                <mat-checkbox
                  [checked]="category.checked || selectedCategories.indexOf(category.tag) > -1"
                  [disableRipple]="readOnlyState"
                  (change)="updateAllSelected($event.checked, category.tag)">
                  {{category.name}}&nbsp;-&nbsp;{{category.tag}}
                </mat-checkbox>
              </mat-list-item>
            }
          </mat-list>
        </mat-card-content>
      </div>
      <div  class="flex-space-between-center flex-row-wrap" >
        <label class="flex-40" >Locations</label>
        <mat-card appearance="outlined"  style="height: 200px; overflow: scroll" class="flex-80">
          @for (location of selectedLocations; track location) {
            <div>
              {{location.name}} ({{location.tag}})
            </div>
          }
        </mat-card>
        @if (!readOnlyState) {
          <div  class="flex-7">
            <button class="add" [attr.data-testid]="'location_edit_button'" mat-icon-button matTooltip="Edit Locations"
              (click)="editLocations()">
              <mat-icon>edit</mat-icon>
            </button>
          </div>
        }
      </div>
    </form>
    <div   class="flex-gap-20px flex-center flex-row" >
      <button mat-raised-button (click)="cancel()">Cancel</button>
      @if (!(form.pristine || form.invalid || readOnlyState)) {
        <button [attr.data-testid]="'update_button'" mat-raised-button (click)="submit(revote)"
          matTooltip="Update Revote"
        >Update</button>
      }
      @if ((form.pristine || form.invalid || readOnlyState)) {
        <div
          matTooltip="This revote cannot be edited because the open date has passed or the form has not been changed.">
          <button [attr.data-testid]="'update_button'" mat-raised-button (click)="submit(revote)"
            [disabled]="form.pristine || form.invalid || readOnlyState"
          >Update</button></div>
        }
      </div>
    </div>
  }
